import React from "react"

const RevenueMappingTab = () => {
  return <div>TODO: Revenue Mapping tab</div>
}

export default RevenueMappingTab
